export default __webpack_public_path__ + "static/media/1500.e3c33739.png";